import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '@env/environment';
import {CSPostResponseModel} from '@service/models';

const API_BASIC_ACCOUNT_URL = environment.depositApiUrl;
const API_OFFER_URL = environment.depositApiUrl + '/offer';

@Injectable({
    providedIn: 'root'
})
export class OfferService {
    constructor(private http: HttpClient) {
    }

    generateOfferForApplication(_applicationId: number): Observable<CSPostResponseModel> {
        return this.http.post<CSPostResponseModel>(API_BASIC_ACCOUNT_URL + `/applications/${_applicationId}/products`, {});
    }

    getApplicationOffers(_applicationId: number): Observable<CSPostResponseModel> {
        return this.http.get<CSPostResponseModel>(API_BASIC_ACCOUNT_URL + `/applications/${_applicationId}/products`);
    }

    updateApplicationOffers(_applicationId: number, products: any): Observable<CSPostResponseModel> {
        return this.http.put<CSPostResponseModel>(API_BASIC_ACCOUNT_URL + `/applications/${_applicationId}/products`, products);
    }

    orderCreditBureauReport(_applicationId: number, _applicantId: number = 0, appModified: boolean = false, data = {}): Observable<CSPostResponseModel> {
        let url = `${environment.apiUrl}/application/bureau/${_applicationId}`;
        if (appModified && _applicantId) {
            url += `/applicant/${_applicantId}/appModified/${appModified}`;
        }
        return this.http.put<CSPostResponseModel>(url, data);
    }

    getCrossSellOffers(_applicationId: number): Observable<any> {
        return this.http.get<any>(environment.apiUrl + `/offer/crosssell/${_applicationId}`);
    }

    getLenderInfo(lenderName: string): Observable<any> {
        const url = `${environment.apiUrl}/lender/${lenderName}/${environment.institutionId}`;
        return this.http.get(url);
    }

    updateSelectedOffer(_applicationId: number, offer: any): Observable<any> {
        //  console.log('update offer =>', JSON.stringify(offer));
        return this.http.put<CSPostResponseModel>(API_OFFER_URL + `/${_applicationId}`, offer);
    }

    getPaymentLink(paymentInfo: any): Observable<any> {
        //  console.log('update offer =>', JSON.stringify(offer));
        return this.http.post<CSPostResponseModel>( `${environment.apiUrl}/payment/url`, paymentInfo);
    }

    generateSelectedProduct(applicationId: number) {
        return this.http.post<CSPostResponseModel>(`${environment.apiUrl}/deposit/account/applications/${applicationId}/generate/selected/product`, {});
    }
}
